<template>
    <div class="fine-print-sticky">
        <div v-show="show">
            {{ finePrintDescription }}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            finePrint: {
                type: Array,
            },
        },
        data() {
            return {
                show : false,
                finePrintDescription : '',
            }
        },
        mounted() {
            this.showFinePrint();
        },
        methods: {
            showFinePrint() {
                if (this.finePrint.length > 0) {
                    this.finePrintDescription = this.finePrint[0].text;
                    this.show = this.finePrint[0].active === 1;
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../../../style/Charts/ViewChart/FilePrintComponent';
</style>
